import RestService from "./RestService";


export default class MyTrainingIncomeService extends RestService {
    constructor() {
        super('/api/myincome/training');
    }

}
